import React from "react";

export const Bible = ({size = 20, ...props}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 512 512"
            {...props}
        >
            <path
                fill="#ea8668"
                d="M292.944 512h-73.888l-2.211-4.422A49.617 49.617 0 00172.223 480H24a24.027 24.027 0 01-24-24V200a24.027 24.027 0 0124-24h464a24.027 24.027 0 0124 24v256a24.027 24.027 0 01-24 24H339.777a49.617 49.617 0 00-44.622 27.578z"
            ></path>
            <path
                fill="#e57055"
                d="M196.259 486.126a49.741 49.741 0 0120.586 21.452l2.211 4.422h73.888l2.211-4.422A49.617 49.617 0 01339.777 480H488a24.027 24.027 0 0024-24V206.325c-48.959 140.362-168.3 247.726-315.741 279.801z"
            ></path>
            <path
                fill="#f2d5a0"
                d="M259.276 480h-6.552a15.981 15.981 0 01-13.679-7.708A50.117 50.117 0 00196.223 448H48a16.019 16.019 0 01-16-16v-48h164.223a65.49 65.49 0 0156.511 32h6.532a65.49 65.49 0 0156.511-32H480v48a16.019 16.019 0 01-16 16H315.777a50.12 50.12 0 00-42.823 24.292A15.978 15.978 0 01259.276 480z"
            ></path>
            <path
                fill="#f7eacd"
                d="M259.276 432h-6.552a15.982 15.982 0 01-13.678-7.707A50.117 50.117 0 00196.223 400H48a16.019 16.019 0 01-16-16V160a16.019 16.019 0 0116-16h148.223c20 0 45.331 9.5 59.777 25.918C270.446 153.5 295.774 144 315.777 144H464a16.019 16.019 0 0116 16v224a16.019 16.019 0 01-16 16H315.777a50.114 50.114 0 00-42.822 24.293A15.985 15.985 0 01259.276 432z"
            ></path>
            <path
                fill="#f4dfb5"
                d="M232.494 152.728A152.084 152.084 0 0132 341.348V384a16.019 16.019 0 0016 16h148.223a50.117 50.117 0 0142.823 24.293A15.982 15.982 0 00252.724 432H256V169.918a73.654 73.654 0 00-23.506-17.19zM349.8 400H464a16.019 16.019 0 0016-16V224a184.074 184.074 0 01-130.2 176z"
            ></path>
            <path
                fill="#f2d5a0"
                d="M264 162.351a63.005 63.005 0 00-8 7.567 63.005 63.005 0 00-8-7.567v268.926a15.974 15.974 0 004.724.723h6.552a15.974 15.974 0 004.724-.723z"
            ></path>
            <path
                fill="#ea8668"
                d="M96.005 345.9a15.98 15.98 0 01-7.888-2.105A15.82 15.82 0 0180 329.871V152a24.027 24.027 0 0124-24h48a24.027 24.027 0 0124 24v177.871a16 16 0 01-24.231 13.719L128 329.33l-23.769 14.26a15.949 15.949 0 01-8.226 2.31z"
            ></path>
            <path
                fill="#efc465"
                d="M384 352h-32a16.019 16.019 0 01-16-16V128h-80a16.019 16.019 0 01-16-16V80a16.019 16.019 0 0116-16h80V16a16.019 16.019 0 0116-16h32a16.019 16.019 0 0116 16v48h80a16.019 16.019 0 0116 16v32a16.019 16.019 0 01-16 16h-80v208a16.019 16.019 0 01-16 16z"
            ></path>
            <path
                fill="#e2b65d"
                d="M336 222.308V336a16.019 16.019 0 0016 16h32a16.019 16.019 0 0016-16V162.148a192.954 192.954 0 01-64 60.16zM480 64h-48.178a191.133 191.133 0 01-13.793 64H480a16.019 16.019 0 0016-16V80a16.019 16.019 0 00-16-16z"
            ></path>
            <path
                fill="#e57055"
                d="M80 293.744v36.127a15.82 15.82 0 008.117 13.923 15.819 15.819 0 0016.114-.2L128 329.33l23.769 14.26A16 16 0 00176 329.871V212.624a128.2 128.2 0 01-96 81.12z"
            ></path>
            <g fill="#e0563f">
                <path d="M120 272a8 8 0 018-8 8 8 0 018 8 8 8 0 01-8 8 8 8 0 01-8-8zM120 240a8 8 0 018-8 8 8 0 018 8 8 8 0 01-8 8 8 8 0 01-8-8zM120 208a8 8 0 018-8 8 8 0 018 8 8 8 0 01-8 8 8 8 0 01-8-8zM120 176a8 8 0 018-8 8 8 0 018 8 8 8 0 01-8 8 8 8 0 01-8-8z"></path>
            </g>
            <circle cx="268" cy="92" r="12" fill="#f7eacd"></circle>
            <circle cx="360" cy="24" r="16" fill="#f7eacd"></circle>
            <circle cx="372" cy="60" r="12" fill="#f7eacd"></circle>
            <circle cx="100" cy="148" r="12" fill="#ffdcd1"></circle>
            <circle cx="296" cy="184" r="16" fill="#fcf8f0"></circle>
        </svg>
    );
}

export default Bible;